import React from "react";
import { TextInput, List, Datagrid, TextField, Filter } from "react-admin";
import { formatName, parseName } from "../util/misc";

const PersonFilter = (props) => {
  return (
    <Filter {...props}>
      <TextInput
        label="Name"
        source="name"
        format={(v) => (v ? formatName(v) : "")}
        parse={(v) => (v ? parseName(v) : "")}
        alwaysOn
      />
    </Filter>
  );
};

const PersonList = (props) => (
  <List {...props} bulkActionButtons={false} filters={<PersonFilter />}>
    <Datagrid rowClick="show">
      <TextField source="id" />
      <TextField source="name" />
    </Datagrid>
  </List>
);

export default PersonList;
